
// Notification Module State
const state = {
  collection: [
    // Notification examples:
    // { dismissible: true, strong: 'Warning', message: 'Something went wrong.', context: 'warning' },
    // { dismissible: true, strong: 'Info', message: 'Something went wrong.', context: 'info' },
    // { dismissible: true, strong: 'Danger!', message: 'Something went wrong.', context: 'danger' }
  ]
}

export default state



// WEBPACK FOOTER //
// ./src/store/notification/state.js